import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=5ceffd92&scoped=true"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"
import style0 from "./Definition.vue?vue&type=style&index=0&id=5ceffd92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceffd92",
  null
  
)

export default component.exports